import { useEffect, useState } from "react";
import Chatbot from "./components/Chatbot";

function App() {
  const [isDarkMode, setIsDarkMode] = useState(false);

  // Check for user's system preference for dark mode
  useEffect(() => {
    if (
      window.matchMedia &&
      window.matchMedia("(prefers-color-scheme: dark)").matches
    ) {
      setIsDarkMode(true);
      document.documentElement.classList.add("dark");
    }
  }, []);

  const toggleDarkMode = () => {
    setIsDarkMode(!isDarkMode);
    document.documentElement.classList.toggle("dark");
  };

  return (
    <div className="bg-gradient-primary m-0 flex min-h-screen items-center justify-center p-5 font-sans transition-colors duration-300">
      <Chatbot />
      <button
        onClick={toggleDarkMode}
        className="btn-dark-toggle"
        aria-label="Toggle dark mode"
        aria-pressed={isDarkMode}
      >
        Toggle Dark Mode
      </button>
    </div>
  );
}

export default App;
